import { render, staticRenderFns } from "./MatchupBlock.vue?vue&type=template&id=5b9c8caf&scoped=true"
import script from "./MatchupBlock.vue?vue&type=script&lang=ts"
export * from "./MatchupBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9c8caf",
  null
  
)

export default component.exports